import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';

const Menu = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMouseLeave = () => {
        setMenuOpen(false);
    };

    return (
        <div className="menuContainer" onMouseLeave={handleMouseLeave}>
            <button className="menuButton" onClick={() => setMenuOpen(!menuOpen)}>
                Menu
            </button>
            {menuOpen && (
                <div className="menuDropdown">
                    <ul className="menuOptions">
                        <li><Link to="/homepage" onClick={() => setMenuOpen(false)}>Homepage</Link></li>
                        <li><Link to="/activities/manage" onClick={() => setMenuOpen(false)}>Activity Management</Link></li>
                        <li><Link to="/activities/my" onClick={() => setMenuOpen(false)}>My Activities</Link></li>
                        <li><Link to="/users" onClick={() => setMenuOpen(false)}>People Management</Link></li>
                        <li><Link to="/skills" onClick={() => setMenuOpen(false)}>Skills Management</Link></li>
                        <li><Link to="/activities" onClick={() => setMenuOpen(false)}>Activities Page</Link></li>
                        <li><Link to="/products" onClick={() => setMenuOpen(false)}>Products</Link></li>
                        <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
                        <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
                        <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
                        <li><Link to="/help" onClick={() => setMenuOpen(false)}>Help</Link></li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Menu;
